<template>
    <div class="nextLink">
        <div class="dashed"></div>
        <div class="next">
            <div class="previous_chapter" v-if="preContent"  @click="goParamsPath(preQuery)">
                <router-link :to="preQuery">
                    上一篇:{{ preContent.contentTitle }}
                </router-link>
            </div>
            <div class="next_chapter" v-if="nextContent"  @click="goParamsPath(nextQuery)">
                <router-link :to="nextQuery">
                    下一篇:{{ nextContent.contentTitle }}
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    /**
     * 
     * @typedef {Object || Array} props 
     * @property {string} nextContent - 下一页.
     * @property {string} preContent - 上一页.
     * @property {boolean} [needQueryDecode=false] - 是否需要路由解码 -- 修改了传参方式这个值现在用不到 Default is false.
     * @property {boolean} [pathOnly=false] - 是否只需要展示可以通过goPath触发父组件方法 Default is false.
     */
    props: ['nextContent', 'preContent', 'needQueryDecode', 'pathOnly'],
    data() {
        return {}
    },
    computed: {
        preQuery() {
            let params = null
                params = JSON.parse(JSON.stringify(this.$route.params || {}))
            params.detailId = this.preContent.contentId
            return {
                name: this.$route.name,
                params: params
            }
        },
        nextQuery() {
            let params = null
                params = JSON.parse(JSON.stringify(this.$route.params || {}))
            params.detailId = this.nextContent.contentId
            return {
                name: this.$route.name,
                params: params
            }
        }
    },
    methods: {
        // goPath(id) {
            // 在父级页面处理操作 ---- 跳转页面不一样所以没在此页面操作
            // if (this.pathOnly) {
            //     this.$emit('goPath', id)
            //     return
            // }
            // let query = null
            // if (this.needQueryDecode) {
            //     // query = JSON.parse(decodeURI(this.$route.query.query))
            // } else {
            //     query = this.$route.query
            // }
            // const params = {...query}
            // params.id = id
            // let params1 = encodeURI(encodeURI(JSON.stringify(params)))
            // this.$router.push(`newDetail?query=${params1}`)
            // location.reload()

            // const { href } = this.$router.resolve(`newDetail?query=${params1}`)
            // window.open(href, '_blank')
        // },
        goParamsPath(params) {
            console.log(params, 'goParamsPath');
            // this.$router.push({
            //     name: 'detailsModel1',
            //     params
            // })
        }
    }
}
</script>

<style scoped>
.dashed {
    width: 100%;
    border-bottom: 1px dashed #8D8D8D;
}
.next > div{
    cursor: pointer;
    font-weight: 500;
    font-size: 14px;
    color: #444444;
}

.next {
    padding: 20px 0 84px 0;
}
.previous_chapter{
    margin-bottom: 8px;
}

@media screen and (max-width: 900px) {
    .next > div{
        font-weight: 500;
        font-size: 14px;
    }

    .next {
        padding: 20px 0 84px 0;
    }
    .previous_chapter{
        margin-bottom: 8px;
    }
}

</style>


// WEBPACK FOOTER //
// src/components/nextLink.vue